import React from 'react';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { X } from 'lucide-react';

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  fullWidth?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({
  isOpen,
  onClose,
  title,
  children,
  fullWidth = false
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent 
        className={`bg-background text-foreground border-l border-border shadow-[-10px_0_15px_-3px_rgba(0,0,0,0.1)] p-0 ${
          fullWidth ? '!max-w-none !w-full !sm:max-w-none' : 'max-w-md sm:max-w-lg w-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-[25px] py-6 border-b border-border">
            <h2 className="text-2xl font-medium text-foreground">{title}</h2>
            <button 
              onClick={onClose}
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Close panel"
            >
              <X size={24} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">
            {children}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default SidePanel;